<template>

	<div id="section-package" class="section is-white-ter pb-4">
		<div class="container">
			<h3 class="title is-3">Your Gearset package</h3>

			<div class="box">
				<div class="columns is-multiline">
					<div class="column">
						<h4 v-text="data.compare.name" class="title is-5"></h4>
						<p v-text="formatTier('compare')"></p>
						<p v-text="formatUsers('compare')" class="is-size-7"></p>
					</div>
					<div class="column">
						<h4 v-text="data.backup.name" class="title is-5"></h4>
						<p v-text="formatTier('backup')"></p>
						<p v-text="formatUsers('backup')" class="is-size-7"></p>
					</div>
					<div class="column">
						<h4 v-text="data.automation.name" class="title is-5"></h4>
						<p v-text="formatTier('automation')"></p>
					</div>
					<div class="column">
						<h4 v-text="data.flowErrorMonitoring.name" class="title is-5"></h4>
						<p v-text="formatTier('flowErrorMonitoring')"></p>
						<p v-text="formatUsers('flowErrorMonitoring')" class="is-size-7"></p>
					</div>
					<div class="column">
						<h4 v-text="data.codeReviews.name" class="title is-5"></h4>
						<p v-text="formatTier('codeReviews')"></p>
						<p v-text="formatUsers('codeReviews')" class="is-size-7"></p>
					</div>
					<div v-for="(addon, key) in selection.addons" :key="key" class="column">
						<h4 v-text="data.addons.products[key].name" class="title is-5"></h4>
						<p v-text="formatAddon(key)"></p>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>

export default {
	name: 'package',

	computed: {
		data() {
			return this.$store.data || {};
		},

		selection() {
			return this.$store.selection || {};
		},
	},

	methods: {
		/* Format the selected tier */
		formatTier(product) {
			const tier = this.selection[product].tier;

			if (tier === '') {
				return 'None';
			} else {
				return this.data[product].products[tier].name;
			}
		},

		/* Format the number of users */
		formatUsers(product) {
			const users = this.selection[product].users;

			if (users === 0) {
				return '';
			} else {
				const plural = users === 1 ? '' : 's';
				return `${this.formatInteger(users)} ${this.data[product].userType}${plural}`;
			}
		},

		/* Format whether an addon is included */
		formatAddon(addon) {
			return this.selection.addons[addon] ? 'Yes' : 'No';
		},
	},
};

</script>

<style lang="scss" scoped>
@import '@gearset/web-core/styles/includes/variables';

.box {
	overflow: hidden;
}

.columns {
	margin: calc(-1.5rem - 1px) !important;
}

.column {
	padding: 1.25rem;
	display: flex;
	flex-direction: column;
	border: 1px solid $white-ter;

	@include until-widescreen {
		width: 25%;
		flex-basis: auto;
	}

	@include mobile {
		width: auto;
	}

	.title {
		font-size: $size-7;
		flex: 1;

		@include desktop {
			min-height: 2rem;
		}
	}
}

</style>
